<template>
    <Search @setState="setState" :boardId="board.boardId"></Search>
    <div class="board">
        <ul class="board__header">
            <li class="board__num">번호</li>
            <li class="board__tit">제목</li>
            <li class="board__date">등록일</li>
        </ul>
        <div class="board__body">
            <component :is="$commonUtils.isExternal(article.linkUrl) ? 'a' : 'router-link'" :href="article.linkUrl" :to="`/${$store.getters.getLang}/${board.boardId}/view?boardNo=${board.boardNo}&articleNo=${article.articleNo}`" :target="$commonUtils.isExternal(article.linkUrl) ? article.linkMethod : '_self'" v-for="(article, index) in list">
                <ul class="board__body__item">
                    <li class="board__num">
                        <span class="tag" v-if="article.noticeYn == 'Y'">공지</span>
                        {{article.noticeYn == 'Y' ? '' :  (totCnt - ((currentNum - 1) * pageRow + index)) }}
                    </li>
                    <li class="board__tit">
                        {{article.title}}
                    </li>
                    <li class="board__date">
                        {{$commonUtils.timestampToDate(article.createdDt)}}
                    </li>
                </ul>
            </component>
        </div>   
    </div>
    <kr_Pagination :totCnt="totCnt" :pageRow="pageRow" :currentNum="currentNum" :pageCount="pageCount" @setNum="setNum"/>
</template>

<script>
import Search from '@/components/kr/common/SearchBox.vue'

export default {
    components: {
        Search,
    },
    props: {
        boardInfo: ''
    },
    data() {
        return {
            board: {},
            list: '',
            pageList: '',
            // pageCount: window.innerWidth > 720 ? 10 : 5,
            pageCount: 5,
            totCnt: 0,

            // 게시글 parameter
            currentNum: this.$route.query.currentNum || 1,
            pageRow: 10,
            //검색 관련 parameter
            title: this.$route.query.title || '',
            content: this.$route.query.content || '',
            searchKeyword: this.$route.query.searchKeyword || '',

        }
    },
    watch: {
        $route(to, from) {
            // 동일 게시판 안에서 이동
            if (to.query != from.query && to.path == from.path) {
                if (Object.keys(to.query).length === 0) this.init()
                for (let i in this.$route.query) {
                    this[i] = this.$route.query[i]
                }

                this.getList()
            }
        },
        // 다른 게시판으로 이동
        boardInfo(oldVal, newVal) {
            this.init()
            this.getList()
        }
    },
    methods: {
        getList() {
            const boardNo = this.boardInfo.boardNo
            const params = {
                hospId: this.$store.getters.getHost,
                boardNo: boardNo,
                startIndex: this.currentNum,
                pageRow: this.pageRow,
                title: this.title,
                content: this.content,
                searchKeyword: this.searchKeyword,
            }
            this.axios.get(this.api.article.list + boardNo, {
                params: params
            })
                .then(res => {
                    this.list = res.data.list
                    this.board = res.data.board
                    this.totCnt = res.data.totCnt

                })
        },
        // 검색 emit
        setState(s, v, p) {
            this.currentNum = 1
            this[s] = v
            this.goPage()
        },
        // pagination emit
        setNum(n) {
            this.currentNum = n
            this.goPage()
        },
        goPage() {
            const obj = { currentNum: this.currentNum, title: this.title, content: this.content, searchKeyword: this.searchKeyword };
            for (const key in obj) {
                if (obj[key] === null || obj[key] === '') {
                    delete obj[key];
                }
            }

            this.$router.push({ path: this.$route.path, query: obj });
        },
        // 데이터 초기화
        init() {
            this.currentNum = 1
            this.title = ''
            this.content = ''
            this.searchKeyword = ''
        }
    },
    mounted() {
        this.getList()
    },
}
</script>

<style scoped></style>